import React from 'react';
import { Box, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

interface BulletListProps {
    items: string[];
    sx?: SxProps<Theme>;
}

export const BulletList: React.FC<BulletListProps> = ({
    items,
    sx
}) => {
    return (
        <Box
            component="ul"
            sx={{
                listStyleType: 'disc',
                pl: 2.5,
                m: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: 0.5,
                ...sx,
            }}
        >
            {items.map((item, index) => (
                <Typography
                    key={index}
                    component="li"
                    variant="body1"
                    sx={{
                        color: 'text.secondary',
                    }}
                >
                    {item}
                </Typography>
            ))}
        </Box>
    );
};

export default BulletList;
